import {
  Flex,
  Heading,
  Img,
  List,
  ListIcon,
  ListItem,
  Text,
  VStack,
} from '@chakra-ui/react';
import { MdCheckCircle } from 'react-icons/md';

import { Button, Link, PageContainer, PageContent } from 'components';
import { usePageTextContent } from 'context/pageTextContent';
import { ZmyleLinks } from 'utils/paths';

export const HowItWorksSection = () => {
  const { content } = usePageTextContent<BenefitsPageContent>();

  const {
    title,
    description,
    advantagesTitle,
    advantages,
    registerButton,
    dashboardPictureUrl,
    cardPictureUrl,
  } = content.howItWorks;

  return (
    <PageContainer>
      <PageContent direction={['column', 'column', 'row']} pt="8rem">
        <VStack align="flex-start" spacing="3rem" minW="50%">
          <VStack align="flex-start" spacing="1.25rem">
            <Heading fontSize="1.5rem">{title}</Heading>

            <Text fontSize="1.125rem" maxW="44rem">
              {description}
            </Text>
          </VStack>

          <VStack align="flex-start" spacing="1.25rem">
            <Heading fontSize="1.5rem">{advantagesTitle}</Heading>

            <List>
              {advantages.map(({ advantage }) => (
                <ListItem key={advantage}>
                  <ListIcon
                    as={MdCheckCircle}
                    fontSize="1.25rem"
                    color="benefit.secondary"
                  />

                  <Text as="span">{advantage}</Text>
                </ListItem>
              ))}
            </List>
          </VStack>

          <Link href={ZmyleLinks.SIGN_UP_COMPANY} isExternal>
            <Button variant="benefit">{registerButton}</Button>
          </Link>
        </VStack>

        <Flex
          h="full"
          w="full"
          mt={['3rem', '3rem', '-3.5rem']}
          ml={[0, 0, '2rem']}
          pos="relative"
        >
          <Img
            src={dashboardPictureUrl}
            w="full"
            maxW="43.75rem"
            alt="Backoffice"
            shadow="0 1px 5px 2px rgba(0,0,0,0.16);"
            rounded="md"
            loading="lazy"
          />

          <Img
            src={cardPictureUrl}
            maxW="16.5rem"
            w="full"
            shadow="0 1px 5px 2px rgba(0,0,0,0.16);"
            rounded="md"
            pos="absolute"
            left="3.5rem"
            bottom="-3.5rem"
            loading="lazy"
          />
        </Flex>
      </PageContent>
    </PageContainer>
  );
};
